module.exports = __webpack_public_path__ + "static/media/Alaa.0fb4b712.jpeg";